import { Box, CircularProgress, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { formatTime } from '../../../utils/dateUtils';

function Voice({ message }: { message: string }) {
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentPlaybackTime, setCurrentPlaybackTime] = useState(0);
  const [audioMessage, setAudioMessage] = useState<HTMLAudioElement | null>(null);
  const [totalDuration, setTotalDuration] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (audioMessage) {
      const updatePlaybackTime = () => {
        setCurrentPlaybackTime(audioMessage.currentTime);
      };
      audioMessage.addEventListener('timeupdate', updatePlaybackTime);
      return () => {
        audioMessage.removeEventListener('timeupdate', updatePlaybackTime);
      };
    }
  }, [audioMessage]);

  useEffect(() => {
    const audioURL = `${process.env.REACT_APP_MEDIA_FILES_BASE_URL}/${message}`;
    const audio = new Audio(audioURL);
    setAudioMessage(audio);

    const setDuration = () => {
      setTotalDuration(audio.duration);
      setLoading(false);
    };
    audio.addEventListener('loadedmetadata', setDuration);
    return () => {
      audio.removeEventListener('loadedmetadata', setDuration);
    };
  }, [message]);

  const handlePlayAudio = () => {
    if (audioMessage) {
      audioMessage.play();
      setIsPlaying(true);
    }
  };

  const handlePauseAudio = () => {
    audioMessage?.pause();
    setIsPlaying(false);
  };

  return (
    <>
      {audioMessage && !isPlaying && (
        <Grid gap="10px" display="flex" flexDirection="row" alignItems="center" width="100%">
          <Box onClick={handlePlayAudio} display="flex" alignItems="center">
            <img
              src="/assets/icons/play-circle.svg"
              alt="start-playing"
              style={{ cursor: 'pointer' }}
            />
          </Box>
          {loading ? (
            <CircularProgress size={17} />
          ) : (
            <Typography variant="bodyRegular" color="primary">
              {formatTime(totalDuration)}
            </Typography>
          )}
        </Grid>
      )}
      {audioMessage && isPlaying && (
        <Grid gap="10px" display="flex" flexDirection="row" alignItems="center" width="100%">
          {formatTime(currentPlaybackTime) !== formatTime(totalDuration) ? (
            <Box display="flex" alignItems="center" onClick={handlePauseAudio}>
              <img
                src="/assets/icons/pause-circle.svg"
                alt="pause-playing"
                style={{ cursor: 'pointer' }}
              />
            </Box>
          ) : (
            <Box onClick={handlePlayAudio} display="flex" alignItems="center">
              <img
                src="/assets/icons/play-circle.svg"
                alt="start-playing"
                style={{ cursor: 'pointer' }}
              />
            </Box>
          )}

          <Typography variant="bodyRegular" color="primary">
            {formatTime(currentPlaybackTime)}
          </Typography>
        </Grid>
      )}
    </>
  );
}

export default Voice;
